export const Games = {
  ADOPTME: 0,
  STEAL_BRAINROT: 1,
  GARDEN: 2,
  PLANTS_BRAINROT: 3,
  MURDER_MYSTERY: 4,
  NIGHTS_FOREST: 5,
  UNIVERSAL_TIME: 6,
  ANIME_RANGERS: 7,
  BLADE_BALL: 8,
  BLOX_FRUITS: 9,
  BLUE_LOCK: 10,
  BRAINROT_EVOLUTION: 11,
  BROOKHAVEN: 12,
  DRESS_IMPRESS: 13,
  FISCH: 14,
  FORSAKEN: 15,
  RIVALS: 16,
  STRONGEST_BATTLEGROUNDS: 17,
  PET_SIMULATOR_99: 18,
  FISH_IT: 19,
  FORGE: 20,
  ESCAPE_TSUNAMI: 21,
  SAILOR_PIECE: 22,
  GRAND_PIECE_ONLINE: 23,
  DA_HOOD: 24,
  GARDEN2: 25
}

export const GamesNames = {
  [Games.ADOPTME]: 'Adopt Me',
  [Games.STEAL_BRAINROT]: 'Steal a Brainrot',
  [Games.GARDEN]: 'Grow a Garden',
  [Games.PLANTS_BRAINROT]: 'Plants vs Brainrots',
  [Games.MURDER_MYSTERY]: 'Murder Mystery 2',
  [Games.NIGHTS_FOREST]: '99 Nights in the Forest',
  [Games.UNIVERSAL_TIME]: 'A Universal Time',
  [Games.ANIME_RANGERS]: 'Anime Rangers',
  [Games.BLADE_BALL]: 'Blade Ball',
  [Games.BLOX_FRUITS]: 'Blox Fruits',
  [Games.BLUE_LOCK]: 'Blue Lock Rivals',
  [Games.BRAINROT_EVOLUTION]: 'Brainrot Evolution',
  [Games.BROOKHAVEN]: 'Brookhaven',
  [Games.DRESS_IMPRESS]: 'Dress to Impress',
  [Games.FISCH]: 'Fisch',
  [Games.FORSAKEN]: 'Forsaken',
  [Games.RIVALS]: 'The Rivals',
  [Games.STRONGEST_BATTLEGROUNDS]: 'The Strongest Battlegrounds',
  [Games.PET_SIMULATOR_99]: 'Pet Simulator 99',
  [Games.FISH_IT]: 'Fish It!',
  [Games.FORGE]: 'The Forge',
  [Games.ESCAPE_TSUNAMI]: 'Escape Tsunami',
  [Games.SAILOR_PIECE]: 'Sailor Piece',
  [Games.GRAND_PIECE_ONLINE]: 'Grand Piece Online',
  [Games.DA_HOOD]: 'Da Hood',
  [Games.GARDEN2]: 'Grow a Garden 2'
}
